import fixedButton from './fixedBtn';
import transitionManager from './transition';
import ThumSlide from './thumSlide';
import effectManager from '../../module/effect';

let effecrt = new effectManager();

export default class actManager {
    constructor(ua) {

        this.ua = Useragnt.tablet ? "pc" : ua;

        this.w;
        this.wHalf;
        this.h;

        /* DOM */
        this.$root = $("#l-root");
        this.$container = $("#p-act");
        this.$trigger = $("#l-fixed-btn");
        this.$ctrl = $("#p-act .js__ctrl-btn");

        /* module */
        this.fixedBtn = (this.ua === "sp")?"" : new fixedButton(this.$trigger);
        this.transition = new transitionManager(window.innerWidth,ua);
        this.thumSlide = new ThumSlide();


        /* STATUS */
        this.current; /* 表示中のセンテンス番号 act=2 */
        this.scInc; /* スクロール位置を取得 */

         /* actセンテンスのステータス */
        this.status = {
            selected : false, /* 日付を選択したか（app.jsに引き継ぐやつ） */
            selectedInner : false, /* 日付を選択したか（act/manager.js内用） */
            linkMouseOn : false, /* リンクにhoverしたか */
            select : {
                day    : "",/* 選択した日にち */
                artist : 0,/* 選択した日にちの中でアクティブなアーティスト */
            },
            out : {/* 表示を消すやつ */
              day : ""
            },
            closeArea : {/* 開いた後に閉じるボタンを表示しておくエリア */
                start : 0,
                end   : 0
            },
            save : {}, /* 状態保存に使う */
            fixbtn : {
                fit : false, /* アーティスト詳細を開いてボタンの位置が固定になっているか？ */
                fitTimer : "", /* fitのsettime監視用 */
                size : {
                    full : 0,
                    half : 0
                }
            },
            spSave : { /* SP用の状態保存 */
                rootH     : 0,
                scrollInc : 0, //  アーティスト選択前のスクロール量を保存し閉じた際に戻す
            },
            sectionMotionFlg:false,/* セクションの表示アニメーションが終わったか */
        }

        this.conf = {
            artist : {
                day18:{
                    0 : {
                        id   : "nick",
                        name : "Nick Heyward"
                    },
                    1 : {
                        id   : "beatniks",
                        name : "THE BEATNIKS"
                    },
                    2 : {
                        id   : "nick-hamish",
                        name : "NED DOHENY & HAMISH STUART"
                    },
                    3 : {
                        id   : "other",
                        name : "MORE LINEUP"
                    },
                },
                day19:{
                    0 : {
                        id   : "cosmopyke",
                        name : "Cosmo Pyke"
                    },
                    1 : {
                        id   : "jess",
                        name : "Jess Glynne"
                    },
                    2 : {
                        id   : "max",
                        name : "MAX"
                    },
                    3 : {
                        id   : "other",
                        name : "MORE LINEUP"
                    },
                }
            },
            MAX : {
                day18 : 3,
                day19 : 3
            }
        }

    }
    init(){

        let _this = this;

        let _clickFlg = false; /* ダブルクリック対策 */

        /* 日付の選択 */
        let _artistList={};
        let _$selectDay; /* 選択した日にち */
        $("#p-act .p-act-day-thum").on("click",function () {

            if(_clickFlg||_this.status.linkMouseOn) return;
            _clickFlg = true;

            TweenMax.set($(".js__act-out"),{opacity:0})

            /* SPでは一旦高さをactに合わせる */
            if(_this.fixedBtn===""||Useragnt.tablet){

                /* SPはfixecのボタンがないので押したサムネで判定 */
                if($(this).parents(".p-act-day").attr("id")==="p-act-day_18"){
                    _this.status.select.day = "18";
                    _this.status.out.day = "19";
                    _artistList = _this.conf.artist.day18;
                }else{
                    _this.status.select.day = "19";
                    _this.status.out.day = "18";
                    _artistList = _this.conf.artist.day19;
                }

                _$selectDay = $("#p-act-day_"+_this.status.select.day);

                _this.status.spSave.rootH = _this.$root.innerHeight();
                _this.status.spSave.scrollInc = _$selectDay.offset().top;


                TweenMax.to(_this.$container, 0.8, {
                    y:_this.scInc-_this.status.spSave.scrollInc,
                    ease:Power2.easeOut,
                    onComplete:function () {
                        TweenMax.set(_this.$root,{height:_this.h});
                        _this.$container.attr("style","")
                        TweenMax.set(_this.$container,{position:"fixed",top:_this.status.select.day=="18"?0:Useragnt.tablet?0:-$("#p-act-day_18").innerHeight(),left:0});
                    }
                });


            }else{

                _$selectDay = $("#p-act-day_"+_this.status.select.day);

                /* PCはFixedのボタンをクリックで遷移させるため、マウス位置で選択している日付を判定 */
                if(_this.fixedBtn.status.position.x < _this.wHalf){
                    _this.status.select.day = "18";
                    _this.status.out.day = "19";
                    _artistList = _this.conf.artist.day18;
                }else{
                    _this.status.select.day = "19";
                    _this.status.out.day = "18";
                    _artistList = _this.conf.artist.day19;
                }
            }






            if(!_this.status.selectedInner){
                /* アーティスト詳細　オープン */
                _this.status.selected = _this.status.selectedInner = true;

               if(_this.fixedBtn) _this.fixedBtn.update("open");

                _this.status.closeArea.start = _this.status.select.day==="18"? 0 : _this.w*0.8375;
                _this.status.closeArea.end   = _this.status.closeArea.start +  _this.w*0.1625;

                // _$selectDay.addClass("is-current");

                /* コントローラーを初期値にリセット */
                _this.controllerUpdate($("#p-act-day_"+_this.status.select.day),_artistList[1].name,_artistList[3].name,_artistList[0].name);

                let _delay = _this.ua==="pc" ? 1e1 : 5e2;
                setTimeout(()=>{
                    _this.transition.start(
                        "open",
                        "#p-act-day_"+_this.status.select.day,
                        "#p-act_"+_this.status.select.day+"_" +  _artistList[_this.status.select.artist].id, /* 選択しているアーティスト */
                        "#p-act-day_"+_this.status.out.day,
                        _this.status.select.day
                    );
                },_delay);

                // _this.fixedBtn.out();

            }else{
                /* アーティスト詳細　クローズ */
                // _this.status.selected = false;
                // _this.fixedBtn.update("close");
                //
                // _$selectDay.removeClass("is-current");
                //
                // _this.transition.start(
                //     "close",
                //     "#p-act-day_"+_this.status.select.day,
                //     "#p-act_"+_this.status.select.day+"_" +  _artistList[_this.status.select.artist].id, /* 選択しているアーティスト */
                //     "#p-act-day_"+_this.status.out.day,
                //     _this.status.select.day
                // );
                // _this.status.select.artist = 0;
            }


            let _resetDelay = this.ua==="pc" ? 1e3:2e3;
            setTimeout(()=> _clickFlg = false,_resetDelay )


        });
        /* 日付を閉じる */
        let _$closeBtn = this.ua === "pc" ? this.$trigger : $("#p-act .p-act-day-thum-close") ;
        _$closeBtn.on("click",function () {
        // $(".p-act-day-body-close").on("click",function () {
            if(!_this.status.selectedInner ) return;
            if(_clickFlg) return;
            _clickFlg = true;
            TweenMax.set($(".js__act-out"),{opacity:1})
            _this.status.selectedInner = false;
            setTimeout(()=>_this.status.selected = false,2e3)
            if(_this.fixedBtn)  _this.fixedBtn.update("close");

            // $("#p-act-day_"+_this.status.select.day).removeClass("is-current");

            _this.transition.start(
                "close",
                "#p-act-day_"+_this.status.select.day,
                "#p-act_"+_this.status.select.day+"_" +  _artistList[_this.status.select.artist].id, /* 選択しているアーティスト */
                "#p-act-day_"+_this.status.out.day,
                _this.status.select.day
            );
            _this.status.select.artist = 0;
            // _this.fixedBtn.show();

            /* SP actに合わせた高さを戻す */
            if(_this.ua === "sp"||Useragnt.tablet){
                TweenMax.set(_this.$root,{height:_this.status.spSave.rootH});
                _this.$container.attr("style","");
                TweenMax.set(window,{scrollTo:_this.status.spSave.scrollInc})
            }


            let _resetDelay = this.ua==="pc" ? 1e3:2e3;
            setTimeout(()=> _clickFlg = false,_resetDelay )
        })


        /* アーティストの切り替え */
        this.$ctrl.on("click",function () {

            if(_clickFlg) return;
            _clickFlg = true;


            let _dir = $(this).hasClass("p-act-day-body-ctrl-next") ? "prev" : "next";

            let _now = _this.getTarget(_this.status.select.artist), /* 現状のnextとprevの値を取得 */
                _select = _dir == "next" ? _now.next : _now.prev, /* _nowと_dirを元に何を選択したかを判定 */
                _next = _this.getTarget(_select); /* 次に表示するものを取得 */

            let _selectDay = _this.status.select.day=="18" ? _this.conf.artist.day18 : _this.conf.artist.day19;

            _this.transition.change(
                "#p-act-day_"+_this.status.select.day,
                _this.status.select.day,
                _selectDay[_select].id, /* 表示するやつ */
                _selectDay[_this.status.select.artist].id, /* 消すやつ */
            );

            _this.status.select.artist = _select;

            /* ナビゲーションアップデート */
            let _$container = $("#p-act-day_"+_this.status.select.day);
            effecrt.show(_$container.find(".js__ctrl-update"),"out");
            setTimeout(function () {
                _this.controllerUpdate(_$container,_selectDay[_next.next].name,_selectDay[_next.prev].name,_selectDay[_select].name);
                setTimeout(function () {
                    effecrt.show(_$container.find(".js__ctrl-update"),"show");
                },5e2);
            },1e3);



            /* ダブルクリック防止用フラグリセット */
            setTimeout(()=> _clickFlg = false,2e3 )

        })

        if(Useragnt.pc) $("#l-fixed-btn,#l-header-navi-list li,#l-sns li,#l-scrolldown").hover(function () {
        // this.$trigger.hover(function () {
                _this.status.linkMouseOn = true;
            },
            function () {
                _this.status.linkMouseOn = false
            }
        );

    }
    controllerUpdate($container,next,prev,current){

        $container.find(".p-act-day-body-ctrl-next .name").text(prev);
        $container.find(".p-act-day-body-ctrl-prev .name").text(next);
        $container.find(".p-act-day-body-ctrl-current .name").text(current);
    }
    getTarget(select){ /* 前後のターゲットを返す */

        let _selectDayMAX = this.status.select.day=="18" ? this.conf.MAX.day18 : this.conf.MAX.day19;

        let _next = select < _selectDayMAX ? select+1 : 0,
            _prev = select > 0 ? select-1 : _selectDayMAX;

        return { next:_next,prev:_prev };

    }
    fixedBtnControll(mouse,fpsRate){
        if(this.current==2&&this.fixedBtn!==""){

            if(!this.fixedBtn.status.show&&!this.status.selected){
                this.fixedBtn.status.show = true;
                // this.fixedBtn.show();
                this.fixedBtn.show()
            }

            // if(this.status.linkMouseOn&&this.fixedBtn.status.show&&!this.status.selected){
            if(this.status.linkMouseOn){
                if(this.status.selected){
                    this.fixedBtn.sizeScaleUp()
                }else{
                    this.fixedBtn.sizeSmall()
                }
            }else{
                if(this.status.selected){
                    this.fixedBtn.sizeScaleDown()
                }else{
                    this.fixedBtn.sizeDefault()
                }
            }

            if(this.status.selectedInner){

                if(!this.status.fixbtn.fit){
                    this.status.fixbtn.fit = true;
                    this.fixedBtn.fit();
                    this.fixedBtn.status.fitTimer = setTimeout(()=>this.fixedBtn.status.fit = true,3e3)
                }
            }else{

                if(this.status.fixbtn.fit){
                    this.status.fixbtn.fit = this.fixedBtn.status.fit = this.fixedBtn.status.fitPosiFlg = false;
                    clearTimeout(this.fixedBtn.status.fitTimer)
                    this.fixedBtn.free();
                }

                if(this.fixedBtn.status.position.x < this.wHalf){
                    if(!this.status.fixbtn.fit&&this.status.sectionMotionFlg&&fpsRate<1.5) this.thumSlide.render(18)
                }else{
                    if(!this.status.fixbtn.fit&&this.status.sectionMotionFlg&&fpsRate<1.5) this.thumSlide.render(19)
                }

            }

            this.fixedBtn.render(mouse);
            if(this.status.fixbtn.fit) { /* app.jsでマウスの加減速しているmoduleに渡すため一旦top.jsへ渡す */
                this.status.fixbtn.size.full = this.fixedBtn.status.size.fullW;
                this.status.fixbtn.size.half = this.fixedBtn.status.size.w;
            }

        }else{
            if(this.fixedBtn.status.show){
                this.fixedBtn.status.show = false;
                this.fixedBtn.out();
            }

        }
    }
    render(mouse,currentSection,scrollInc,fpsRate){

        this.current = currentSection;
        this.scInc = scrollInc;


        if(this.ua=="pc") this.fixedBtnControll(mouse,fpsRate);



    }
    resize(w,h) {

        this.w = w;
        this.h = h;
        this.wHalf =this.fixedBtn ?  this.w / 2 - this.fixedBtn.status.size.w :this.w / 2 ;

        this.transition.resize(this.w,this.h);

        if(this.ua==="sp") TweenMax.set($(".p-act-day-body"),{height:this.h});
    }
}